import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "orders flex justify-start relative flex-nowrap" }
const _hoisted_2 = { class: "absolute inset-0 h-screen" }
const _hoisted_3 = { class: "w-389" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-389" }, null, -1)
const _hoisted_5 = { class: "bg-opacityBackground backdrop-filter backdrop-blur-6px z-10 pt-14 pb-5 px-6 fixed h-full w-389" }
const _hoisted_6 = { class: "flex justify-between mb-6" }
const _hoisted_7 = { class: "relative h-42 mb-6 w-full me-3" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "absolute end-2 top-2.5" }
const _hoisted_10 = { class: "border border-inputBorder w-12 h-42" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "overflow-hidden w-full h-full" }
const _hoisted_13 = { class: "orders-list overflow-y-scroll mb-10 h-screen pe-7 box-content w-full h-full" }
const _hoisted_14 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 bg-moreBg flex justify-center"
}
const _hoisted_15 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrdersMap = _resolveComponent("OrdersMap")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_ReturnedItem = _resolveComponent("ReturnedItem")!
  const _component_ReturnedOrderModal = _resolveComponent("ReturnedOrderModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OrdersMap, {
        id: 'orders-page',
        showDarkstores: true,
        drivers: _ctx.driverLocations
      }, null, 8, ["drivers"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PageTitle, { title: "orders.returnedItemsTitle" }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _ctx.$t('placeholders.orders_filter'),
              class: "h-42 absolute py-3.5 ps-3.5 pe-9 top-0 start-0 w-full h-full block appearance-none bg-transparent",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
            }, null, 8, _hoisted_8), [
              [_vModelText, _ctx.searchValue]
            ]),
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_BaseIcon, { name: "search" })
            ])
          ]),
          _createElementVNode("button", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_BaseIcon, { name: "filter" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (item, index) => {
              return (_openBlock(), _createBlock(_component_ReturnedItem, {
                key: index,
                onEditOrder: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editModal($event))),
                order: item
              }, null, 8, ["order"]))
            }), 128))
          ]),
          (_ctx.paginations && _ctx.paginations.totalPage && _ctx.paginations.totalPage > _ctx.pageNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMore())),
                  class: "py-6 w-full text-sm text-black opacity-60"
                }, _toDisplayString(_ctx.loading ? 'loading...' : _ctx.$t('buttons.more')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_ReturnedOrderModal, {
            key: 0,
            "order-data": _ctx.detailedOrder,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = !_ctx.showModal))
          }, null, 8, ["order-data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}